import Vue from 'vue';
import { loadLanguage } from '@/core/i18nUtils';
import router from './router';
import createStore from './store';

export default (i18n) => {
  const Transaction = () => import('./main');

  const vue = new Vue({
    el: '#transaction',
    i18n,
    router,
    store: createStore(),
    data() {
      return {
        loadedI18n: false,
      };
    },
    render(h) {
      if (this.loadedI18n) {
        return h(Transaction);
      }
      return h('p', '');
    },
    async beforeCreate() {
      await loadLanguage(this, [
        'main',
        'find',
        'details',
        'transaction',
        'stock_info',
      ]);

      switch (window.lang) {
        case 'english': this.$i18n.locale = 'en'; break;
        case 'gb': this.$i18n.locale = 'gb'; break;
        default: this.$i18n.locale = 'zh';
      }
      this.loadedI18n = true;
    },
  });

  return vue;
};
